"use client";

import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { FC, forwardRef, useMemo } from "react";
import { Tooltip } from "antd";
import { useSnapshot } from "valtio";
import { LoginInfo } from "./LoginInfo";
import { HomeStore } from "@/src/store";
import { useHomeListAction } from "@hooks";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Menu/MenuFooter";
import { socialLinks } from "@/src/const";
import Link from "next/link";

interface MenuContentProps {
  isShowLogo?: boolean;
  onCancel?: () => void;
  onLinkClick?: () => void;
  locale?: string;
}

export const MenuFooterMobile: FC<MenuContentProps> = ({ locale }) => {
  return (
    <div>
      <LoginInfo locale={locale} clickEnable={true} />
    </div>
  );
};

export const MenuFooter = forwardRef<HTMLDivElement, MenuContentProps>(
  ({ onCancel, locale }, ref) => {
    const { getAboutPath } = useHomeListAction();
    const { isOpen } = useSnapshot(HomeStore);
    const I18n = useMemo(
      () => I18nUtil.createScoped(Translations, locale),
      [locale],
    );

    return (
      <div ref={ref}>
        <LoginInfo locale={locale} />
        <div
          className={cn(
            "flex w-full flex-col justify-center border-t border-border_inverse_transparent10",
            { hidden: !isOpen },
          )}
        >
          {/* V3.0.3: Figma 100551:387440 — Meta/Icons: [book-opened] + [X-logo] */}
          <div className="flex flex-row py-2 px-4 gap-3 items-center">
            <Tooltip
              title={
                <span className="text-content_secondary body_x">
                  {I18n.t("About Us")}
                </span>
              }
              color={ospThemes.colors.background_solid_secondary}
              arrow={false}
              autoAdjustOverflow
              classNames={{
                body: "border-border_white_transparent10 border !px-[6px] !py-1 !min-h-5",
              }}
              placement="bottom"
            >
              <Link
                aria-label="About Us"
                data-openreplay-label={`Menu Footer Link | ${getAboutPath().replace("/en", "")}`}
                id="lnk-menu-footer-about"
                href={getAboutPath().replace("/en", "")}
                target="_blank"
                prefetch={false}
                className="p-0.5"
                onClick={onCancel}
              >
                <Icon
                  name="book-opened"
                  color={ospThemes.colors.content_primary}
                  size={12}
                />
              </Link>
            </Tooltip>
            <Link
              aria-label="Twitter"
              data-openreplay-label={`Menu Footer Link | ${socialLinks.twitter}`}
              id="lnk-menu-footer-x"
              href={socialLinks.twitter}
              target="_blank"
              className="p-0.5"
            >
              <Icon
                name="X-logo"
                size={12}
                color={ospThemes.colors.content_primary}
              />
            </Link>
          </div>
        </div>
      </div>
    );
  },
);

MenuFooter.displayName = "MenuFooter";
